export default __webpack_public_path__ + "static/media/camera.475016a4.svg";